import {SET_CURRENT_USER, SET_PRIVACY_STATUS} from '../actions/current-user-actions';

export function currentUser(state = {}, {type, payload}) {
  switch (type) {
    case SET_CURRENT_USER:
      return {...state, ...payload};

    case SET_PRIVACY_STATUS:
      return {...state, privacyStatus: payload};

    default:
      return state;
  }
}
